import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type BoardsLoopsLoopController from 'webapp/controllers/boards/loops/loop';

import type BoardLoop from 'webapp/models-custom/board-loop';

export default class BoardsLoopsLoopRoute extends Route {
	@service('model-manager/board-loops')
	declare mmBoardLoopsService: Service.ModelManager.BoardLoops;
	@service('navigation') declare navigationService: Service.Navigation;

	override model(params: { loop_id: string }): BoardLoop | void {
		let model;

		if (params) {
			model = this.mmBoardLoopsService.findModel(params.loop_id);
		}

		if (!model) {
			this.navigationService.replaceRoute('boards.loops');
			return;
		}

		return model;
	}

	override setupController(
		controller: BoardsLoopsLoopController,
		model: BoardLoop,
		transition: PublicTransition,
	): void {
		super.setupController(controller, model, transition);
		controller.activate();
	}
}
